import { ErrorType } from "../../../components/CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import { BtnAskForQuote } from "../../../components/common/BtnAskForQuote/BtnAskForQuote";
import { BtnJumpToEasy } from "../../../components/common/BtnJumpToEasy/BtnJumpToEasy";
import DevErrorTester from "../../../components/common/DevErrorTester";
import { FooterTextLabel } from "../../../configurator/renderer/components/FooterTextLabel/FooterTextLabel";
import { useUiTranslator } from "../../../hooks/useUiTranslator";
import { useEasySession } from "../../../providers/easySessionProvider";
import { theme as FooterTheme } from "../../../theme/footerTheme";
import { customPalette } from "../../../theme/theme";

import { JSX } from "react";

import { VMLineItems } from "@4pace-cpq/core";
import { Box, Container, ThemeProvider, Typography } from "@mui/material";

export function CartViewFooter({
  lineItems,
  setErrorList,
  allConfigsComplete,
}: {
  lineItems?: VMLineItems[] | null;
  allConfigsComplete: boolean;
  setErrorList: (error: ErrorType[]) => void;
}): JSX.Element {
  const t = useUiTranslator();
  const { isLoggedIntoEasy } = useEasySession();

  return (
    <ThemeProvider theme={FooterTheme}>
      <Box
        mt="16px"
        sx={{
          position: "fixed",
          display: "flex",
          boxShadow: "0 -15px 15px 0 rgba(0,0,0,.125)",
          backgroundColor: customPalette.primary.dark,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <FooterTextLabel />
        <Container maxWidth={false}>
          <Box
            display="flex"
            justifyContent="flex-end"
            py={2}
            gap={2}
            alignItems="center"
          >
            {import.meta.env.DEV ? <DevErrorTester /> : null}
            <Typography variant="caption" color="#fff">
              {!lineItems
                ? t(
                    "CustomApp:error.projectList.noItems",
                    "There are no projects",
                  )
                : !allConfigsComplete
                  ? t(
                      "CustomApp:error.projectList.incompleteItems",
                      "Some projects are still incomplete",
                    )
                  : ""}
            </Typography>
            {isLoggedIntoEasy ? (
              <BtnJumpToEasy
                lineItems={lineItems}
                setErrorList={setErrorList}
                disabled={
                  !lineItems || !allConfigsComplete || !isLoggedIntoEasy
                } //checking isLoggedIntoEasy here again is currently useless
              />
            ) : (
              <BtnAskForQuote disabled={!lineItems || !allConfigsComplete} />
            )}
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
